import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-modal";
import { updateProfil } from "../../actions/user.action";
import {
  getAnnoncesByUser,
  getAnnoncesFavoris,
} from "../../actions/annonce.action";
import { deleteAnnonce } from "../../actions/annonce.action";
import { dateParser } from "../Utils";
import CarteAnnonces from "../Annonce/CarteAnnonces";
import { FaExclamationTriangle } from "react-icons/fa";
import PaiementModal from "../Annonce/AnnoncesInformations";

const UpdateProfil = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.userReducer);
  const annoncesByUser =
    useSelector((state) => state.annonceReducer.annoncesByUser) || [];
  const favoris = useSelector((state) => state.annonceReducer.favoris) || [];

  const [view, setView] = useState("annonces");
  const [loadedUserAnnonces, setLoadedUserAnnonces] = useState(false);
  const [loadedFavoris, setLoadedFavoris] = useState(false);

  useEffect(() => {
    if (userData._id && !loadedUserAnnonces) {
      dispatch(getAnnoncesByUser(userData._id));
      setLoadedUserAnnonces(true);
    }
  }, [userData._id, loadedUserAnnonces, dispatch]);

  useEffect(() => {
    if (userData._id && !loadedFavoris) {
      dispatch(getAnnoncesFavoris(userData._id));
      setLoadedFavoris(true);
    }
  }, [userData._id, loadedFavoris, dispatch]);

  const handleViewChange = (type) => {
    setView(type);
    if (type === "favoris" && !loadedFavoris) {
      dispatch(getAnnoncesFavoris(userData._id));
      setLoadedFavoris(true);
    }
  };

  const [openModal, setOpenModal] = useState(false);

  const [pseudo, setPseudo] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [city, setCity] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [updateForm, setUpdateForm] = useState(false);

  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const handleDeleteAnnonce = (id) => {
    if (window.confirm("Voulez-vous vraiment supprimer cette annonce ?")) {
      dispatch(deleteAnnonce(id));
    }
  };

  useEffect(() => {
    if (userData) {
      setPseudo(userData.pseudo || "");
      setFirstname(
        userData.firstname
          ? userData.firstname.charAt(0).toUpperCase() +
              userData.firstname.slice(1).toLowerCase()
          : ""
      );
      setLastname(userData.lastname ? userData.lastname.toUpperCase() : "");
      setCity(userData.city || "");
      setPhone(userData.phone || "");
      setEmail(userData.email || "");
    }
  }, [userData]);

  const handleUpdate = (e) => {
    e.preventDefault();
    const updatedData = { pseudo, firstname, lastname, city, phone, email };
    dispatch(updateProfil(userData._id, updatedData));
    setUpdateForm(false);
  };

  const handlePasswordUpdate = (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setPasswordError("Les mots de passe ne correspondent pas.");
      return;
    }
    setPasswordError("");

    dispatch(updateProfil(userData._id, { password: newPassword }));

    setNewPassword("");
    setConfirmPassword("");
    setShowPasswordForm(false);
  };

  return (
    <div className="profilPage">
      <div className="profilContainer">
        <h3>
          <FaExclamationTriangle />
          Pour créer des annonces, merci de renseigner toutes les informations
          utilisateurs
        </h3>
        <h1>Profil de {userData.pseudo}</h1>
        <div className="updateProfil">
          <div className="rightPart">
            <div className="titleRightPart">
              <p>Informations :</p>
              <button
                className="button updateInfo"
                onClick={() => setUpdateForm(!updateForm)}
              >
                {updateForm ? "Annuler" : "Modifier mes informations"}
              </button>
            </div>

            {!updateForm ? (
              <>
                <label>Pseudo : {pseudo}</label>
                <label>Prénom : {firstname}</label>
                <label>Nom : {lastname}</label>
                <label>Ville : {city}</label>
                <label>Téléphone : {phone}</label>
                <label>Email : {email}</label>
              </>
            ) : (
              <form className="changeForm" onSubmit={handleUpdate}>
                <span>
                  <label>Prénom :</label>
                  <input
                    type="text"
                    value={firstname}
                    onChange={(e) => setFirstname(e.target.value)}
                  />
                </span>

                <span>
                  <label>Nom :</label>
                  <input
                    type="text"
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value.toUpperCase())}
                  />
                </span>

                <span>
                  <label>Ville :</label>
                  <input
                    type="text"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                </span>

                <span>
                  <label>Téléphone :</label>
                  <input
                    type="text"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </span>
                <div className="flex">
                  <button className="button" type="submit">
                    Mettre à jour
                  </button>
                  <h3>
                    Dernière modification : {dateParser(userData.updatedAt)}
                  </h3>
                </div>
              </form>
            )}
            <div className="zoneUpdatePassword">
              <label>Mot de passe: </label>
              <button
                className="button updatePassword"
                onClick={() => setShowPasswordForm(!showPasswordForm)}
              >
                {showPasswordForm ? "Annuler" : "Modifier mon mot de passe"}
              </button>

              {showPasswordForm && (
                <form onSubmit={handlePasswordUpdate}>
                  <label>Nouveau mot de passe :</label>
                  <input
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />

                  <label>Confirmer le mot de passe :</label>
                  <input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />

                  {passwordError && (
                    <p style={{ color: "red" }}>{passwordError}</p>
                  )}

                  <button
                    type="submit"
                    disabled={!newPassword || !confirmPassword}
                  >
                    Mettre à jour le mot de passe
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
        <h4>Membres depuis le {dateParser(userData.createdAt)}</h4>
      </div>
      <div className="annonceProfil">
        <p onClick={() => setOpenModal(true)}>
          Rappel des règles pour les annonces.
        </p>
        <div className="navAnnonce">
          <button
            className={`button ${view === "annonces" ? "active" : ""}`}
            onClick={() => handleViewChange("annonces")}
          >
            Mes annonces ({annoncesByUser.length})
          </button>
          <button
            className={`button ${view === "favoris" ? "active" : ""}`}
            onClick={() => handleViewChange("favoris")}
          >
            Mes favoris ({favoris.length})
          </button>
        </div>
        <div className="annonces-container">
          {view === "annonces" && annoncesByUser.length === 0 && (
            <p>Aucune annonce publiée.</p>
          )}
          {view === "favoris" && favoris.length === 0 && (
            <p>Aucun favori ajouté.</p>
          )}

          {(view === "annonces" ? annoncesByUser : favoris).map((annonce) => (
            <CarteAnnonces
              key={annonce._id}
              annonce={annonce}
              utilisateurId={annonce.utilisateur}
              isOwner={view === "annonces"}
            />
          ))}
          {annoncesByUser.utilisateur === userData._id && (
            <button
              className="button deleteAnnonce"
              onClick={() => handleDeleteAnnonce(annoncesByUser._id)}
            >
              Supprimer
            </button>
          )}
        </div>
      </div>

      <PaiementModal isOpen={openModal} onClose={() => setOpenModal(false)} />
    </div>
  );
};


export default UpdateProfil;
